import { Link, useNavigate } from "react-router-dom";
import "../css/MainNavigation.css";
import { useState, useEffect } from "react";
import "react-slideshow-image/dist/styles.css";
import { Button } from "primereact/button";
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";

import colors from '../colors';


function MainNavigation(props) {

  const [stickyMenu,setStickyMenu] = useState(false);
  const user = localStorage.getItem('seo_app')? JSON.parse(localStorage.getItem('seo_app')): { name: "" };
  const name = user.name ? user.name : "تازه وارد";
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
  const navigate = useNavigate();
  const { online, setOnline } = useOnlineStatus();
  const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);


//go to top of the page:
useEffect(() => {
  window.scrollTo(0, 0)
}, []);

 
 //check sticky menu:
useEffect(() => {

  const handleScroll = () =>
  {
    const isSticky = window.scrollY > 700;
    setStickyMenu(isSticky);
  };
  window.addEventListener("scroll",handleScroll);

  return() => {
    window.removeEventListener("scroll",handleScroll);
  };

  
}, []);

const logout = () => 
  {
    console.log("atemped to log out");
  
    apiClient.get(process.env.REACT_APP_BACK+"/users/logout", config)
    .then((response) => {
      if (response.status == 200)
      {
         // Set online status to false
         setOnline(false);
         
         navigate("/");
      }
      
    })
    .catch((error) => {
      console.log(error);
 
    });

    //delete user cache:
    localStorage.removeItem('seo_app');
    localStorage.removeItem('userToken');

  
  }

  

  return (
    <header id="header" className={stickyMenu ? "sticky-menu active" : "sticky-menu" }>
      <span className="login">

      
        <span style={{marginLeft:'10px'}}>

       
{/* 
        {!props.online && 
        <Link to= "/login">
          <Button
            label="داشبورد کاربران"
            className="login-button"
          />
          </Link>} */}


          {props.online && 
        <Link to= {"/dashboard"} style={{marginRight:'10px'}}>
          <Button
            label="داشبورد کاربران"
            className="login-button"
          />
          </Link>}

          

          
          {" "}
          &nbsp;
         
        </span>
        

         <span style={{display:"flex", alignItems:"center",gap:"10px"}}>

      {!props.online &&
      (<Link to="/register">
        <Button
          label="ورود/ثبت نام"
          className="register-button"
        />
        </Link>)}

        {props.online && desktop &&
        (<div style={{display:'grid'}}>
          <span>
          {"سلام " +name + " عزیز"}
          </span>
        {props.online && props.user.role==="manager" &&
          (
            <span style={{color:"#000000", fontFamily:"peyda-bold",marginleft:'10px',cursor:'pointer',fontSize:'13px'}}
              onClick={() => navigate("/manager-dashboard") }
            >داشبورد مدیریت</span>
          )
          }
        
        
        </div>)
        }

        {props.online && desktop &&
        (<Button id="logout-button" tooltip="خروج" tooltipOptions={{ position: 'bottom'}} onClick={logout}>
        <i className="pi pi-power-off"></i>
      </Button>)}

      
      </span>


      </span>

      
     
      
          <span className="logo" onClick={() => navigate("/")}>
           
            <img  className="logo-image" src={ require('../images/logo.png') }  alt={process.env.REACT_APP_ALT}/>
         
        
            <h3>
            {process.env.REACT_APP_PROJECT_NAME}
            </h3>
        
            </span>
           
        
     
    </header>
  );
}

export default MainNavigation;
